<script>
	export let text = "";
	export let buttons = [];
	export let onButton = () => {};

	const getClickHandler = (button, index) => {
		return () => {
			onButton(button, index);
		};
	};
</script>

<div class="confirm">
	<div>
		{text}
	</div>
	<div>
		{#each buttons as button, index}
			<button on:click={getClickHandler(button, index)}>{button}</button>
		{/each}
	</div>
</div>

<style>
	.confirm {
		position: absolute;
		top: 0;
		left: 0;

		background-color: #000000;
		color: #ffffff;

		width: 100%;
		height: 100%;

		display: flex;
		justify-content: space-evenly;
		align-items: center;
		flex-direction: column;

		z-index: 999;
	}

	button {
		background-color: transparent;
		border-radius: 3px;
		padding: 5px 5px;
		min-width: 100px;
		border-color: #000000;

		color: #ffffff;
	}
</style>